export const styles = {
  securityItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: '24px',
  },
  borderBottom: {
    borderBottom: '1px solid #F0F0FF',
    marginBottom: '24px',
  },
  securityButton: {
    height: 44,
    padding: '10px 8px',
    borderRadius: 4,
    border: '1px solid #E2E2FC',
    backgroundColor: '#FFF',
  },
  securityButtonDisabled: {
    height: 44,
    padding: '10px 8px',
    borderRadius: 4,
    color: '#E2E2FC',
    border: '1px solid #E2E2FC',
    backgroundColor: 'transparent',
    fontWeight: 700,
  },
  connectContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttonLabel: {
    color: '#2E3860',
    fontWeight: 700,
  },
  connectLabel: {
    color: 'grey',
    fontSize: '16px',
  },
  tooltip: {
    maxWidth: 160,
    fontSize: '16px',
    backgroundColor: '#0C172C',
    textAlign: 'center',
    color: '#FFF',
    padding: '8px 8px',
  },
}
